import CircleInfo from "@dana/Icons/CircleInfo";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import { IconMemo } from "@insite/mobius/Icon";
import Typography from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import React, { useState } from "react";
import { css } from "styled-components";

interface OwnProps {
    extendedStyles?: SalesRepModelStyles;
}

type Props = OwnProps;

export interface SalesRepModelStyles {
    wrapper?: InjectableCss;
    messageStyles?: InjectableCss;
}

export const salesRepModelStyles: SalesRepModelStyles = {
    wrapper: {
        css: css`
            position: relative;
            width: 100%;
            background-size: cover;
            background-position: center;
            border-radius: 8px;
            cursor: pointer;
        `,
    },
   
};

const ProductDetailsInternalUseOnlyMessage = ({  extendedStyles }: Props) => {
    const [styles] = useState(() => mergeToNew(salesRepModelStyles, extendedStyles));
   
    return (
        <div>
            <StyledWrapper {...styles.messageStyles}>
                <Typography as="p" className="info-message-box">
                    <IconMemo size={13} src={CircleInfo} />{" "}
                    {siteMessage("ProductDetailPage_InternalUse_Message", "This part number is for internal use only and cannot be purchased.")}{" "}                    
                </Typography>
            </StyledWrapper>
           
        </div>
    );
};

export default ProductDetailsInternalUseOnlyMessage;
